import React, { useEffect, useRef, useState } from 'react';
import QRCode from 'react-qr-code';
// import codeQr from "../../assets/client/qr-code.png";
import './client.css';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { clients_services } from '../../services/clients_services';
import { toPng } from 'html-to-image';
import moment from 'moment';

const ClientDashboad = () => {
    const qrRef = useRef(null)
    const [wait, setWait] = useState(true)
    const [client, setClient] = useState([])
    const [company, setCompany] = useState([])
    const navigate = useNavigate()
    const [typeIntervention, setTypeIntervention] = useState('');

    useEffect(() => {
        clients_services.getClientInfo()
            .then((res) => {
                // console.log("clientRes:::::::::: ", res.data.Client)
                // console.log("companyRes:::::::::: ", res.data.Structure)
                setClient(res.data.Client)
                setCompany(res.data.Structure)
                setTypeIntervention(res.data.Structure.TypeInterventionId)
            })
            .catch((err) => {
                console.log(err)
                if (err.response) {
                    if (err.response.status === 400) {
                        navigate("/auth/loginClient");
                    }
                    if (err.response.status === 404) {
                        navigate("/auth/loginClient");
                    }
                    if (err.response.status === 500) {
                        toast.error("Erreur d'exécution dans l'application , veillez vous reconnecter.")
                    }
                }
            })
    }, []);

    // put client into qr code 
    const clientInfo = JSON.stringify({
        Id: client.id,
        Nom: client.nom,
        Prenom: client.prenom,
        Telephone: client.numeroTel,
        Sexe: client.sexe,
        DateCreation: client.createdAt,
        Structure: company.nom,
        Bonus: client.bonus
    });

    // Function to format the current date and time as 'YYYY-MM-DD_HH-MM'
    const getFormattedDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}_${hours}-${minutes}`;
    };

    // Function to download QR code as image with custom filename
    const downloadQrCode = () => {
        setWait(false)
        if (qrRef.current === null) {
            return;
        }
        // Format the filename as "GuestName-EventName-DateTime.png"
        const dateTime = getFormattedDateTime(); // Get the current date and time
        const filename = `${client.nom}_${client.prenom}-${dateTime}.png`;

        toPng(qrRef.current)
            .then((dataUrl) => {
                const link = document.createElement('a');
                link.download = filename; // Set the filename dynamically-
                link.href = dataUrl;
                link.click();
                setWait(true);
            })
            .catch((err) => {
                setWait(true)
                console.error('Error generating image', err);
                toast.error("Erreur lors du téléchargement du code qr")
            });
    };

    return (
        <div className="container mt-5" >
            <div className="card conteneurCode">
                <div className="card-header bg-secondary">
                    <h5>Statistiques du Client : <strong className='ml-2 capitalize'>{client.nom + " " + client.prenom}</strong> </h5>
                </div>
                <div className="card-body">

                    <div className="row ">
                        <div className="col-md-6 shadow text-center qr-container">
                            <div className="qr-code-container">
                                <QRCode
                                    className='link qr-code'
                                    ref={qrRef}
                                    onClick={downloadQrCode}
                                    value={clientInfo}
                                    size={256}
                                />
                                {/* <img src={codeQr} alt="code qr" sizes="40" /> */}

                                {
                                    wait ?
                                        <button onClick={downloadQrCode} className="bouton-qr" title='Cliquer pour télécharger le Code QR' >
                                            Télécharger le QR Code
                                        </button>
                                        :
                                        <button className="bouton-qr"> <span className="spinner-border text-black spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Téléchargement..</button>
                                }
                            </div>
                        </div>

                        <div className="col-md-6">
                            {/* <div className="texte ">Bonjours tous le monda , c'est</div> */}
                            <div className="fw-bold name mt-2"><h4><strong className='capitalize shadow px-2 py-2'>{client.nom + " " + client.prenom}</strong></h4></div>

                            <div className="mt-4"><i className='fas fa-map-marker-alt mr-2 ml-2'></i>{client.localisation}</div>

                            <div className="mt-4"><i className='fas fa-phone mr-2 ml-2'></i> (+237) {client.numeroTel} </div>

                            <div className="mt-4"><i className={typeIntervention === 2 ? "fas fa-dumbbell mr-2 ml-2" : "fas fa-infinity mr-2 ml-2"}></i> {client.intervention} <strong>{typeIntervention === 1 ? "Visite(s)" : "Kg"}</strong></div>

                            {/* <div className="mt-3"><i className='fas fa-infinity mr-2 ml-2'></i>{clientd.intervention1}  <strong>Visite(s)</strong></div> */}
                            <div className="mt-4 capitalize">
                                {
                                    client.sexe === 'masculin' ? <i className="fas  mr-2 ml-2 fa-mars"></i> :
                                        client.sexe === 'feminin' ? <i className="fas  mr-2 ml-2 fa-venus"></i> : ''
                                }
                                {client.sexe}
                            </div>

                        </div>

                    </div>

                    <hr />

                    <div className="row text-center">
                        <div className="col-md-6">
                            <div className="border shadow rounded py-2 bg-light">
                                <h6 className="text-primary pt-3 text-bold">Nombre de Visites</h6>
                                <p className="display-4 text-bold text-primary">{client.trace ? client.trace : 0}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="border shadow rounded py-2 bg-light">
                                <h6 className="text-success pt-3 text-bold">Nombre de Bonus</h6>
                                <p className="display-4 text-bold text-success">{client.bonus}</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default ClientDashboad;